"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asSingleFileFormEndpoint = exports.asDownloadEndpoint = exports.asStandardEndpoint = void 0;
/** Utility function for typechecking of BasicRoute */
var asStandardEndpoint = function (x) { return x; };
exports.asStandardEndpoint = asStandardEndpoint;
/** Utility function for typechecking of DownloadRoute  */
var asDownloadEndpoint = function (x) { return x; };
exports.asDownloadEndpoint = asDownloadEndpoint;
/** Utility function for typechecking of DownloadRoute  */
var asSingleFileFormEndpoint = function (x) { return x; };
exports.asSingleFileFormEndpoint = asSingleFileFormEndpoint;
//# sourceMappingURL=routes.js.map